import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.css';
import 'assets/scss/paper-dashboard.scss';
import 'perfect-scrollbar/css/perfect-scrollbar.css';
import { Provider } from 'react-redux';
import { Helmet } from 'react-helmet';
import { setUserInSession } from './auth/AuthActions';
import { prepareStore } from './redux/Store';
import AlertContainer from './common/components/alert/AlertContainer';
import './App.css';
import Content from './common/components/Content/Content';
import AuthRefreshToken from './auth/AuthRefreshToken';
import RouterPaths, { DIRECT_DEBIT } from './constants/RouterPaths';
import StripeDirectDebitCheckout from './stripedirectdebit/StripeDirectDebitCheckout';
import StripeDirectDebitSuccess from './stripedirectdebit/StripeDirectDebitSuccess';
import StripeDirectDebitCancel from './stripedirectdebit/StripeDirectDebitCancel';
import NotFound from './notfound/NotFound';
import './assets/scss/app.scss';

export const store = prepareStore();
setUserInSession(store.dispatch);

// prevent sessionStorage duplication (for tab duplicate)
window.addEventListener('beforeunload', () => {
  sessionStorage.removeItem('__lock');
});
if (sessionStorage.getItem('__lock')) {
  sessionStorage.clear();
}
sessionStorage.setItem('__lock', '1');

function StripeDirectDebitRoutes() {
  return (
    <div className="stripe-direct-debit-wrapper">
      <Routes>
        <Route path={RouterPaths.STRIPE_CHECKOUT} element={<StripeDirectDebitCheckout />} />
        <Route path={RouterPaths.STRIPE_SUCCESS} element={<StripeDirectDebitSuccess />} />
        <Route path={RouterPaths.STRIPE_CANCEL} element={<StripeDirectDebitCancel />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}

// Create a component that uses the useLocation hook
function App() {
  const env = process.env.REACT_APP_DEPLOYMENT_ENVIRONMENT;

  const { location } = window;

  return (
    <>
      <Helmet>
        <meta name="robots" content={env === 'PROD' ? 'index, follow' : 'noindex, nofollow'} />
      </Helmet>
      <Provider store={store}>
        <AuthRefreshToken />
        <BrowserRouter basename="/">
          {location.pathname.includes(DIRECT_DEBIT) ? (
            <StripeDirectDebitRoutes />
          ) : (
            <>
              <Content />
              <AlertContainer />
            </>
          )}
        </BrowserRouter>
      </Provider>
    </>
  );
}

// Create a root using createRoot API
const root = createRoot(document.getElementById('root'));

// Render the app using root.render()
root.render(<App />);
